module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isLoadingData) ? _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.form.event.title + ' / ' + _vm.form.title,
      "back-route": "event.index",
      "edit-route-name": "event.update.basic-data",
      "item": _vm.form
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "show-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_c('div', [_vm._v("Local: "), _c('strong', [_vm._v(_vm._s(_vm.form.place.description))])]), _vm._v(" "), _c('div', [_vm._v("Email Contato: "), _c('strong', [_vm._v(_vm._s(_vm.form.contact_email))])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_c('div', [_vm._v("Data de Início: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.start_datetime)))])]), _vm._v(" "), _c('div', [_vm._v("Data de Término: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.end_datetime)))])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "33%"
    }
  }, [_c('div', [_vm._v("Data de Início das Inscrições: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.start_registration_datetime)))])]), _vm._v(" "), _c('div', [_vm._v("Data de Término das Inscrições: "), _c('strong', [_vm._v(_vm._s(_vm._f("dateTimeEnToBr")(_vm.form.end_registration_datetime)))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "event-actions"
  }, [_c('router-link', {
    staticClass: "-button1",
    class: {
      '-current': _vm.currentView === 'home'
    },
    attrs: {
      "to": {
        name: 'event.show.home',
        params: {
          id: _vm.form.id,
          mainEventId: _vm.form.event_id
        }
      },
      "title": "Início"
    }
  }, [_c('div', {
    staticClass: "event-link-box"
  }, [_c('div', {
    staticClass: "event-box"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', [_vm._v("Início")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "-button2",
    class: {
      '-current': _vm.currentView === 'registration'
    },
    attrs: {
      "to": {
        name: 'event.index.registrations',
        params: {
          id: _vm.form.id,
          mainEventId: _vm.form.event_id
        }
      },
      "title": "Inscrições"
    }
  }, [_c('div', {
    staticClass: "event-link-box"
  }, [_c('div', {
    staticClass: "event-box"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("Inscrições")])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "-button3",
    class: {
      '-current': _vm.currentView === 'event.index.papers.nao_designado'
    },
    attrs: {
      "to": {
        name: 'event.index.papers',
        params: {
          id: _vm.form.id,
          statusKey: 'nao_designado'
        }
      },
      "title": "Submissões Recebidas"
    }
  }, [_c('div', {
    staticClass: "event-link-box"
  }, [_c('div', {
    staticClass: "event-box"
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" "), _c('span', [_vm._v("Submissões Recebidas")]), _vm._v(" "), _c('span', {
    staticClass: "total"
  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.form.papers['nao_designado']))])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "-button4",
    class: {
      '-current': _vm.currentView === 'event.index.papers.aprovado_pela_triagem'
    },
    attrs: {
      "to": {
        name: 'event.index.papers',
        params: {
          id: _vm.form.id,
          statusKey: 'aprovado_pela_triagem'
        }
      },
      "title": "Aprovadas pela Triagem"
    }
  }, [_c('div', {
    staticClass: "event-link-box"
  }, [_c('div', {
    staticClass: "event-box"
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" "), _c('span', [_vm._v("Aprovadas pela Triagem")]), _vm._v(" "), _c('span', {
    staticClass: "total"
  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.form.papers['aprovado_pela_triagem']))])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "-button5",
    class: {
      '-current': _vm.currentView === 'event.index.papers.em_avaliacao'
    },
    attrs: {
      "to": {
        name: 'event.index.papers',
        params: {
          id: _vm.form.id,
          statusKey: 'em_avaliacao'
        }
      },
      "title": "Submissões Atribuidas"
    }
  }, [_c('div', {
    staticClass: "event-link-box"
  }, [_c('div', {
    staticClass: "event-box"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("Submissões Atribuidas")]), _vm._v(" "), _c('span', {
    staticClass: "total"
  }, [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm.form.papers['em_avaliacao']))])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "-button6",
    class: {
      '-current': _vm.currentView === 'event.index.papers.finalizado'
    },
    attrs: {
      "to": {
        name: 'event.index.papers',
        params: {
          id: _vm.form.id,
          statusKey: 'finalizado'
        }
      },
      "title": "Submissões Avaliadas"
    }
  }, [_c('div', {
    staticClass: "event-link-box"
  }, [_c('div', {
    staticClass: "event-box"
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('span', [_vm._v("Submissões Finalizadas")])])])])], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "event": _vm.form
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Dados da Evento")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16fc67ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/Show.vue
// module id = 722
// module chunks = 2